import { render, staticRenderFns } from "./SubjectGrid.vue?vue&type=template&id=5135ae9f&"
import script from "./SubjectGrid.vue?vue&type=script&lang=js&"
export * from "./SubjectGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports